import { render, staticRenderFns } from "./SaleInfo.vue?vue&type=template&id=032c4e07&scoped=true&"
import script from "./SaleInfo.vue?vue&type=script&lang=js&"
export * from "./SaleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032c4e07",
  null
  
)

export default component.exports